/* eslint-disable max-lines */
export const brazeMockData = {
  G: [
    {
      id: 'Njc0MGJhZWI0ZDc4MTIwMDY1ZjA0NmFjXyRfY2M9YjE4ZWNkNmQtNTliNi1jYjdhLTBlMWUtNDYzMGIzM2E3MmQ1JmRpJmRtJm12PTY3NDBiYWViNGQ3ODEyMDA2NWYwNDZhZSZvZCZwaT13ZnMmdz02NzQwYmFlYjRkNzgxMjAwNjVmMDQ2YTkmd3A9MjAyNS0wMy0wNlQxNyUzQTE2JTNBMTQuMDAwWiZ3dj02NzQwYmFlYjRkNzgxMjAwNjVmMDQ2YmI=',
      title: 'HAPPi™',
      description: 'Daily enrichment activities rooted in fun.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6740baeb4d78120065f046ae/041bdab0e432ebbdc102092ae8be0dad4e0dcb46/original.jpg?1732295406',
      created: '2025-03-06T17:21:19.000Z',
      updated: '2025-03-06T17:21:19.000Z',
      categories: [],
      expiresAt: '2025-03-07T17:21:19.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: '100 pts - Week 1 Completion',
        campaign: 'HAPPi',
        location: 'home, discover',
        priority: '30',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjcyMjUyMjE3ODExMmEwMDY2NjY5ZTg2XyRfY2M9NDUxYzM3NTAtM2QwYS1hOWJhLWFkNDItMTFhYTljNWY3Mjg4Jm12PTY3MjI1MjIxNzgxMTJhMDA2NjY2OWU4OCZwaT1jbXA=',
      title: 'Refer a Friend. Earn a Bonus.',
      description: 'Share myPurina for 100 extra points.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6722522178112a0066669e88/6775babc190e10e54a8e4f7b6477e3c89045b33b/original.jpg?1730303701',
      created: '2025-03-06T16:30:00.000Z',
      updated: '2025-03-06T16:30:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T16:30:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Earn 100 Points',
        campaign: 'Referrals Program',
        location: 'home, discover',
        priority: '95',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdiY2U5YTdkYjA3OTkwMDY0MTVjNjY3XyRfY2M9MWI2Njg3ZTUtZDNjMS05MGQ0LTkxNGUtMzA2NWFhMjM1NzkyJm12PTY3YmNlOWE3ZGIwNzk5MDA2NDE1YzY2OSZwaT1jbXA=',
      title: 'Claim your offer exclusively in the myPurina app',
      description:
        "Download myPurina and get $100 off a detailed analysis of your pet's unique microbiome, plus a custom report and personal\nrecommendations to help your pet maintain a healthy gut. Offer ends March 21, all Standard myPurina Terms & Conditions Apply.",
      url: 'https://mypurina.onelink.me/z05v/fsphjzoz',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67bce9a7db0799006415c669/03b5ecba92a68820918ee22a3dfce2710ae5b167/original.jpg?1740435379',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'petivity_mak_sale',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5YTU5YTNkZTc5ZTkwMDYzY2Y3OGQ4XyRfY2M9MTc1MjI4NzItZjEzOS03MDQwLWEwYjEtMWMwZGZiZWVmOTM1Jm12PTY3OWE1OWEzZGU3OWU5MDA2M2NmNzhkYSZwaT1jbXA=',
      title: '2x Points on DentaLife',
      description: 'Upload a DentaLife receipt, and earn double the points, now through April.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/679a59a3de79e90063cf78da/9f8df466baee82083827e6eba1b76ea4f9470073/original.jpg?1738170050',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Ends 4/30',
        campaign: 'dentalife2x',
        location: 'offers',
        priority: '20',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdiN2VmNWE0MGViMGIwMDYyMjJiYzdlXyRfY2M9NGM5NWY2NjktMzU3ZC01ZTdjLTY4OWItYjRkNTg5YjljYTI3Jm12PTY3YjdlZjVhNDBlYjBiMDA2MjIyYmM4MCZwaT1jbXA=',
      title: 'Earn 600 Bonus Points',
      description:
        'Buy 5 or more cans of Purina ONE wet dog food. Earn an extra bonus when you upload your recipe.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67b7ef5a40eb0b006222bc80/1f0e32cc65532a5dc89cb882e99d18a0ac569c1b/original.jpg?1740108217',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'large_tall',
        add_desc: 'Ends 4/30',
        campaign: 'Purina_One',
        location: 'offers',
        priority: '25',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5ZDA2MjBkYTQ1NTcwMDY0MGIzZjQ0XyRfY2M9NTI1YmQ1NDEtYzE5My1mZDc1LWFkYzUtNTIyYmIyMzZlMzZhJm12PTY3OWQwNjIwZGE0NTU3MDA2NDBiM2Y0NiZwaT1jbXA=',
      title: 'Download myPurina. Earn Double Points.',
      description:
        "Help keep your pets' breath fresh and their teeth clean while earning pawsome rewards! Get the myPurina app, and earn 2X points on all Dentalife purchases now through the end of April.",
      url: 'https://mypurina.onelink.me/z05v/dentalife2x',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/679d0620da455700640b3f46/617ad988f2b95726d3ea2e9e49bbad2ba69e843f/original.jpg?1738344270',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        brand: 'dentalife',
        format: 'web_classic_card',
        campaign: 'dentalife2x',
        location: 'product_listing',
        priority: '2',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdhYTY3MzE4NTkzODYwMDY3OWUwODU3XyRfY2M9NTBhMmE1YzEtOTY0NS0xOGU5LTliNzMtMzNiMDEwMDIwZjcxJm12PTY3YWE2NzMxODU5Mzg2MDA2NzllMDg1OSZwaT1jbXA=',
      title: 'Download myPurina.Earn Double Points.',
      description:
        "Make a Difference in your cat's health from day ONE, and earn pawsome rewards! Get the myPurina app, and earn 2X points on all Purina ONE Dry Cat Food purchases now through the end of May.",
      url: 'https://mypurina.onelink.me/z05v/ponebrazeplp',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67aa673185938600679e0859/ca8a4e9474dacca299fea9736f65ac1e80c07463/original.jpg?1739221378',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        brand: 'purina_one',
        format: 'web_classic_card',
        species: 'cat',
        campaign: 'pone2x',
        location: 'product_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdhNjU3MmNjODYzY2QwMDY1OGQxOThhXyRfY2M9YjA5MDhhNDEtNTk3MS00OTcwLTYzNjMtMjg5YjE2YWI0ZTU0Jm12PTY3YTY1NzJjYzg2M2NkMDA2NThkMTk4NiZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsplp',
      aspectRatio: 1,
      viewed: true,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67a6572cc863cd00658d1986/4883f5ba5c786d86b7f6fa8fc676fa5c534f6ec3/original.jpg?1738954543',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'product_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc2NTljN2NkZjNjZjEwMDY0OTAyOGJiXyRfY2M9NDkwNTgyNmMtMWIwMC0zNjUwLThmMDUtYTEyM2FmNjBiZWJjJm12PTY3NjU5YzdjZGYzY2YxMDA2NDkwMjhiNiZwaT1jbXA=',
      title: 'Tell Us What You Think',
      description: 'Earn extra points when you leave a review.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67659c7cdf3cf100649028b6/e958fb465e267bcaf5b87b3f1281fcffc3c46cf2/original.jpg?1734712448',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-04-05T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Earn 50 Bonus Points',
        campaign: 'ratings_reviews',
        location: 'home,discover',
        priority: '51',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdiZGU4MGM3NmJiNzgwMDYyODIxYTdjXyRfY2M9MDYyNDAzNzktM2MxYi01YTdkLTg4NTQtOGQyMzE3NzA3ZTg3Jm12PTY3YmRlODBjNzZiYjc4MDA2MjgyMWE3ZSZwaT1jbXA=',
      title: 'Want a Bonus?',
      description: 'Earn 20 extra points when you submit a receipt with any wet food purchase.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67bde80c76bb780062821a7e/ec556cbcfda485675ba095043c326a0f2ad31bc5/original.jpg?1740501043',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Upload a Receipt',
        campaign: 'wet_pet_promo_offer_VA',
        location: 'offers',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9OTExYzU2ZWItNDQ2NS05YzljLWE2NDEtZWZhZmFiNTZmNTRhJm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-13T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjcxODRjZGEyZTQwYTcwMDc1YTZjNGU2XyRfY2M9MzQyZWIwODEtYjM0Ny0zMGZhLTYxZWMtMGY4MTFhMTc2YjI5Jm12PTY3MTg0Y2RhMmU0MGE3MDA3NWE2YzRlMSZwaT1jbXA=',
      title: 'Just for You',
      description: "Special promos we think you'll love!",
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67184cda2e40a70075a6c4e1/9efd666ef44fffca91d7b2345fd75e20c0a13610/original.png?1729645790',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-04-05T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'global_promotions',
        location: 'home,discover',
        priority: '40',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjcxYThiNWFkNWJhMjIwMDczZTQ5NGQ1XyRfY2M9ODgwNWRmY2QtMDM2OC00Y2ViLWQxMGEtYjNkNTVjNGYxOTEyJm12PTY3MWE4YjVhZDViYTIyMDA3M2U0OTRkMSZwaT1jbXA=',
      title: 'Join Us to Advance Pet Care',
      description:
        'Help us build smarter pet products by joining the Petivity Innovation community!  Find out how.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/671a8b5ad5ba220073e494d1/6cc9b3d00b4334fb1e3f9ca18a9a5e1d3a0210f7/original.png?1729792863',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-04-05T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'rewards_2',
        location: 'discover',
        priority: '90',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9Nzc2MDQ4NGQtMjI1ZC1lYWI2LTBlNWYtZGVhODgxNTk5NzNkJm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-03-05T09:00:00.000Z',
      updated: '2025-03-05T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-12T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdiZGY4YTczOWYwZjQwMDYzNGNjZDdmXyRfY2M9NDk1NmJmM2UtNjA4Ni04Y2FmLWRjMTUtMWU4Y2Q1ZDY4YmM4Jm12PTY3YmRmOGE3MzlmMGY0MDA2MzRjY2Q4MSZwaT1jbXA=',
      title: 'One Year FREE',
      description: 'Anytime, anywhere consultations with \ntrusted vet professionals via Petzey',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67bdf8a739f0f400634ccd81/2d4835dd4f389cb3b0a567eaae6f234f2e47eb93/original.jpg?1740503470',
      created: '2025-03-04T09:00:00.000Z',
      updated: '2025-03-04T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-04-03T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Special Offer!',
        campaign: 'petzey2025',
        location: 'home',
        priority: '40',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9ODljNDYyOWEtZDAxOS1lMDE3LWIwZTEtMDJhODA4NDcxNDRhJm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-03-04T09:00:00.000Z',
      updated: '2025-03-04T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-11T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9MjQ1ZjBiZDUtMDkyOC1lMjA5LThiMGQtNDRkMTgzMzU1Zjk5Jm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-03-03T09:00:00.000Z',
      updated: '2025-03-03T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-10T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9NjM2MGY4YWUtYzkyNy1hODRiLTdiZGItM2JkOWEzMWE2Yzk1Jm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-02-28T09:00:00.000Z',
      updated: '2025-02-28T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc1MjAxZTEyZjBjN2EwMDY2NGZhNTg5XyRfY2M9OGMzMTkyZmUtNjViZi02ZTE1LTFlMWQtZmUwM2JiYTMxMjYyJm12PTY3NTIwMWUxMmYwYzdhMDA2NjRmYTU4MCZwaT1jbXA=',
      title: 'The App for You and Your Pet',
      description:
        'Get freebies, earn rewards and more! myPurina gives you 10 points for every $1 spent on Purina products, plus a bonus at sign up!',
      url: 'https://mypurina.onelink.me/z05v/plp1725915304',
      aspectRatio: 1,
      viewed: true,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/675201e12f0c7a00664fa580/684ea704a5ce42ef8a10cab8b964b401a36e4bc3/original.jpg?1733427686',
      created: '2025-02-22T05:55:00.000Z',
      updated: '2025-02-22T05:55:00.000Z',
      categories: [],
      expiresAt: '2025-03-24T05:55:00.000Z',
      linkText: 'Download myPurina',
      extras: {
        format: 'web_classic_card',
        campaign: 'mypurina_2',
        location: 'product_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc1MjAyMWMzM2RlYWUwMDYzNzZkOGE5XyRfY2M9NWE2ZDljZTMtNWVlZC1iODJmLTEzOTYtMmM2ZGI4ODdmOWYwJm12PTY3NTIwMjFjMzNkZWFlMDA2Mzc2ZDhhMCZwaT1jbXA=',
      title: 'The App for You and Your Pet',
      description:
        'Get freebies, earn rewards and more! myPurina gives you 10 points for every $1 spent on Purina products, plus a bonus at sign up!',
      url: 'https://mypurina.onelink.me/z05v/plp1725915304',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6752021c33deae006376d8a0/d71f2d22098f572bca8284c37dc83a78ab656d38/original.jpg?1733427744',
      created: '2025-02-22T05:55:00.000Z',
      updated: '2025-02-22T05:55:00.000Z',
      categories: [],
      expiresAt: '2025-03-24T05:55:00.000Z',
      linkText: 'Download myPurina',
      extras: {
        format: 'web_classic_card',
        campaign: 'mypurina_2',
        location: 'product_listing',
        priority: '2',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5MTcyNTZiNTIzOGYwMDYzODUzNWU3XyRfY2M9ZWVlOGMzMmUtYWNmYS02YTMzLWY1MjQtNjA3ZWNhNTAxNzhiJm12PTY3OTE3MjU2YjUyMzhmMDA2Mzg1MzVlOSZwaT1jbXA=',
      title: 'Earn Double Points',
      description: 'Upload a Moist & Meaty receipt, and earn 2X the points on your purchase!',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67917256b5238f00638535e9/9c25ef65720a3512e60cfc60aa305a11332925fb/original.jpg?1737585505',
      created: '2025-02-17T09:00:00.000Z',
      updated: '2025-02-17T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-19T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Ends 12/31',
        campaign: 'MoistMeaty_2x',
        location: 'offers',
        priority: '45',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjcyYjkzMDMyN2FkZDgwMDYzMTAzZWE5XyRfY2M9MWQ4MTVkOTQtMzYxNC1kOTg4LTJhMTAtNjg0NWU3YzE1NGU5Jm12PTY3MmI5MzAzMjdhZGQ4MDA2MzEwM2VhNSZwaT1jbXA=',
      title: 'Train and Play',
      description: 'Find articles and videos to help connect with your pet.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/672b930327add80063103ea5/4f96d7986a35b9e31c4ec9dbc0353a8017374999/original.jpg?1730908934',
      created: '2025-02-14T09:00:00.000Z',
      updated: '2025-02-14T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-16T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'Train and Play',
        location: 'discover',
        priority: '97',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc1OWNkOGM3OGI4YzcwMDY0Mzc1Nzk3XyRfY2M9OWNlZjFkNzQtZWJmYS0wZjY2LWZhNzQtYTAwY2ZmNjYxZTI5Jm12PTY3NTljZDhjNzhiOGM3MDA2NDM3NTc5MyZwaT1jbXA=',
      title: 'Calculate a Custom Feeding Plan',
      description: 'Get a personalized guide for your pet',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6759cd8c78b8c70064375793/e852afa25bd717b1c5450cc6119bc2fe5cf28296/original.png?1733938576',
      created: '2025-02-14T09:00:00.000Z',
      updated: '2025-02-14T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-16T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'feeding_guide',
        location: 'discover',
        priority: '70',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjczNGZmNzFiMTRjNWUwMDY2NDMyNDRmXyRfY2M9NDBkOGJlZjctMjJiNC0zMDc0LTAwNmEtNGJiNDhkZWYwYTU5JmRpJmRtJm12PTY3MzRmZjcxYjE0YzVlMDA2NjQzMjQ1MSZvZCZwaT13ZnMmdz02NzM0ZmY3MWIxNGM1ZTAwNjY0MzI0NGMmd3A9MjAyNS0wMi0xM1QxOSUzQTQ1JTNBMTYuMDAwWiZ3dj02NzM0ZmY3MWIxNGM1ZTAwNjY0MzI0NTY=',
      title: 'Earn more points when you scan!',
      description: 'Have a receipt? Upload now to earn even more points.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6734ff71b14c5e0066432451/50add40b3b46fd029a89e13e5996413d3f1a4fcd/original.jpg?1731526516',
      created: '2025-02-13T19:45:22.000Z',
      updated: '2025-02-13T19:45:22.000Z',
      categories: [],
      expiresAt: '2025-03-15T19:45:22.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'upload receipt',
        location: 'home',
        priority: '10',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjczNGYzYTAwYzIzMTcwMDY0NzBjYjE3XyRfY2M9N2ZkMGE1ZGItNTUyMS01ZTZhLTQ1NWItMTIxZWU3MGFiNTdlJmRpJmRtJm12PTY3MzRmM2EwMGMyMzE3MDA2NDcwY2IxOSZvZCZwaT13ZnMmdz02NzM0ZjNhMDBjMjMxNzAwNjQ3MGNiMTQmd3A9MjAyNS0wMi0xM1QxOCUzQTU1JTNBMTcuMDAwWiZ3dj02NzM0ZjNhMDBjMjMxNzAwNjQ3MGNiMWU=',
      title: "Find your pet's perfect food.",
      description: 'Try the Pet Food Finder today. ',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6734f3a00c2317006470cb19/0dcb310e244f86806a3bbd8756ddc17bd31f437a/original.jpg?1731523491',
      created: '2025-02-13T18:55:52.000Z',
      updated: '2025-02-13T18:55:52.000Z',
      categories: [],
      expiresAt: '2025-03-15T18:55:52.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'pet food finder',
        location: 'home, discover',
        priority: '20',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
  ],
  cards: [
    {
      id: 'Njc0MGJhZWI0ZDc4MTIwMDY1ZjA0NmFjXyRfY2M9YjE4ZWNkNmQtNTliNi1jYjdhLTBlMWUtNDYzMGIzM2E3MmQ1JmRpJmRtJm12PTY3NDBiYWViNGQ3ODEyMDA2NWYwNDZhZSZvZCZwaT13ZnMmdz02NzQwYmFlYjRkNzgxMjAwNjVmMDQ2YTkmd3A9MjAyNS0wMy0wNlQxNyUzQTE2JTNBMTQuMDAwWiZ3dj02NzQwYmFlYjRkNzgxMjAwNjVmMDQ2YmI=',
      title: 'HAPPi™',
      description: 'Daily enrichment activities rooted in fun.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6740baeb4d78120065f046ae/041bdab0e432ebbdc102092ae8be0dad4e0dcb46/original.jpg?1732295406',
      created: '2025-03-06T17:21:19.000Z',
      updated: '2025-03-06T17:21:19.000Z',
      categories: [],
      expiresAt: '2025-03-07T17:21:19.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: '100 pts - Week 1 Completion',
        campaign: 'HAPPi',
        location: 'home, discover',
        priority: '30',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjcyMjUyMjE3ODExMmEwMDY2NjY5ZTg2XyRfY2M9NDUxYzM3NTAtM2QwYS1hOWJhLWFkNDItMTFhYTljNWY3Mjg4Jm12PTY3MjI1MjIxNzgxMTJhMDA2NjY2OWU4OCZwaT1jbXA=',
      title: 'Refer a Friend. Earn a Bonus.',
      description: 'Share myPurina for 100 extra points.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6722522178112a0066669e88/6775babc190e10e54a8e4f7b6477e3c89045b33b/original.jpg?1730303701',
      created: '2025-03-06T16:30:00.000Z',
      updated: '2025-03-06T16:30:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T16:30:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Earn 100 Points',
        campaign: 'Referrals Program',
        location: 'home, discover',
        priority: '95',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdiY2U5YTdkYjA3OTkwMDY0MTVjNjY3XyRfY2M9MWI2Njg3ZTUtZDNjMS05MGQ0LTkxNGUtMzA2NWFhMjM1NzkyJm12PTY3YmNlOWE3ZGIwNzk5MDA2NDE1YzY2OSZwaT1jbXA=',
      title: 'Claim your offer exclusively in the myPurina app',
      description:
        "Download myPurina and get $100 off a detailed analysis of your pet's unique microbiome, plus a custom report and personal\nrecommendations to help your pet maintain a healthy gut. Offer ends March 21, all Standard myPurina Terms & Conditions Apply.",
      url: 'https://mypurina.onelink.me/z05v/fsphjzoz',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67bce9a7db0799006415c669/03b5ecba92a68820918ee22a3dfce2710ae5b167/original.jpg?1740435379',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'petivity_mak_sale',
        location: 'article_detail',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5YTU5YTNkZTc5ZTkwMDYzY2Y3OGQ4XyRfY2M9MTc1MjI4NzItZjEzOS03MDQwLWEwYjEtMWMwZGZiZWVmOTM1Jm12PTY3OWE1OWEzZGU3OWU5MDA2M2NmNzhkYSZwaT1jbXA=',
      title: '2x Points on DentaLife',
      description: 'Upload a DentaLife receipt, and earn double the points, now through April.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/679a59a3de79e90063cf78da/9f8df466baee82083827e6eba1b76ea4f9470073/original.jpg?1738170050',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Ends 4/30',
        campaign: 'dentalife2x',
        location: 'offers',
        priority: '20',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdiN2VmNWE0MGViMGIwMDYyMjJiYzdlXyRfY2M9NGM5NWY2NjktMzU3ZC01ZTdjLTY4OWItYjRkNTg5YjljYTI3Jm12PTY3YjdlZjVhNDBlYjBiMDA2MjIyYmM4MCZwaT1jbXA=',
      title: 'Earn 600 Bonus Points',
      description:
        'Buy 5 or more cans of Purina ONE wet dog food. Earn an extra bonus when you upload your recipe.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67b7ef5a40eb0b006222bc80/1f0e32cc65532a5dc89cb882e99d18a0ac569c1b/original.jpg?1740108217',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'large_tall',
        add_desc: 'Ends 4/30',
        campaign: 'Purina_One',
        location: 'offers',
        priority: '25',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5ZDA2MjBkYTQ1NTcwMDY0MGIzZjQ0XyRfY2M9NTI1YmQ1NDEtYzE5My1mZDc1LWFkYzUtNTIyYmIyMzZlMzZhJm12PTY3OWQwNjIwZGE0NTU3MDA2NDBiM2Y0NiZwaT1jbXA=',
      title: 'Download myPurina. Earn Double Points.',
      description:
        "Help keep your pets' breath fresh and their teeth clean while earning pawsome rewards! Get the myPurina app, and earn 2X points on all Dentalife purchases now through the end of April.",
      url: 'https://mypurina.onelink.me/z05v/dentalife2x',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/679d0620da455700640b3f46/617ad988f2b95726d3ea2e9e49bbad2ba69e843f/original.jpg?1738344270',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        brand: 'dentalife',
        format: 'web_classic_card',
        campaign: 'dentalife2x',
        location: 'product_listing',
        priority: '2',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdhYTY3MzE4NTkzODYwMDY3OWUwODU3XyRfY2M9NTBhMmE1YzEtOTY0NS0xOGU5LTliNzMtMzNiMDEwMDIwZjcxJm12PTY3YWE2NzMxODU5Mzg2MDA2NzllMDg1OSZwaT1jbXA=',
      title: 'Download myPurina.Earn Double Points.',
      description:
        "Make a Difference in your cat's health from day ONE, and earn pawsome rewards! Get the myPurina app, and earn 2X points on all Purina ONE Dry Cat Food purchases now through the end of May.",
      url: 'https://mypurina.onelink.me/z05v/ponebrazeplp',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67aa673185938600679e0859/ca8a4e9474dacca299fea9736f65ac1e80c07463/original.jpg?1739221378',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        brand: 'purina_one',
        format: 'web_classic_card',
        species: 'cat',
        campaign: 'pone2x',
        location: 'product_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdhNjU3MmNjODYzY2QwMDY1OGQxOThhXyRfY2M9YjA5MDhhNDEtNTk3MS00OTcwLTYzNjMtMjg5YjE2YWI0ZTU0Jm12PTY3YTY1NzJjYzg2M2NkMDA2NThkMTk4NiZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsplp',
      aspectRatio: 1,
      viewed: true,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67a6572cc863cd00658d1986/4883f5ba5c786d86b7f6fa8fc676fa5c534f6ec3/original.jpg?1738954543',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'product_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc2NTljN2NkZjNjZjEwMDY0OTAyOGJiXyRfY2M9NDkwNTgyNmMtMWIwMC0zNjUwLThmMDUtYTEyM2FmNjBiZWJjJm12PTY3NjU5YzdjZGYzY2YxMDA2NDkwMjhiNiZwaT1jbXA=',
      title: 'Tell Us What You Think',
      description: 'Earn extra points when you leave a review.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67659c7cdf3cf100649028b6/e958fb465e267bcaf5b87b3f1281fcffc3c46cf2/original.jpg?1734712448',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-04-05T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Earn 50 Bonus Points',
        campaign: 'ratings_reviews',
        location: 'home,discover',
        priority: '51',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdiZGU4MGM3NmJiNzgwMDYyODIxYTdjXyRfY2M9MDYyNDAzNzktM2MxYi01YTdkLTg4NTQtOGQyMzE3NzA3ZTg3Jm12PTY3YmRlODBjNzZiYjc4MDA2MjgyMWE3ZSZwaT1jbXA=',
      title: 'Want a Bonus?',
      description: 'Earn 20 extra points when you submit a receipt with any wet food purchase.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67bde80c76bb780062821a7e/ec556cbcfda485675ba095043c326a0f2ad31bc5/original.jpg?1740501043',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Upload a Receipt',
        campaign: 'wet_pet_promo_offer_VA',
        location: 'offers',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9OTExYzU2ZWItNDQ2NS05YzljLWE2NDEtZWZhZmFiNTZmNTRhJm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-13T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjcxODRjZGEyZTQwYTcwMDc1YTZjNGU2XyRfY2M9MzQyZWIwODEtYjM0Ny0zMGZhLTYxZWMtMGY4MTFhMTc2YjI5Jm12PTY3MTg0Y2RhMmU0MGE3MDA3NWE2YzRlMSZwaT1jbXA=',
      title: 'Just for You',
      description: "Special promos we think you'll love!",
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67184cda2e40a70075a6c4e1/9efd666ef44fffca91d7b2345fd75e20c0a13610/original.png?1729645790',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-04-05T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'global_promotions',
        location: 'home,discover',
        priority: '40',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjcxYThiNWFkNWJhMjIwMDczZTQ5NGQ1XyRfY2M9ODgwNWRmY2QtMDM2OC00Y2ViLWQxMGEtYjNkNTVjNGYxOTEyJm12PTY3MWE4YjVhZDViYTIyMDA3M2U0OTRkMSZwaT1jbXA=',
      title: 'Join Us to Advance Pet Care',
      description:
        'Help us build smarter pet products by joining the Petivity Innovation community!  Find out how.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/671a8b5ad5ba220073e494d1/6cc9b3d00b4334fb1e3f9ca18a9a5e1d3a0210f7/original.png?1729792863',
      created: '2025-03-06T09:00:00.000Z',
      updated: '2025-03-06T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-04-05T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'rewards_2',
        location: 'discover',
        priority: '90',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9Nzc2MDQ4NGQtMjI1ZC1lYWI2LTBlNWYtZGVhODgxNTk5NzNkJm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-03-05T09:00:00.000Z',
      updated: '2025-03-05T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-12T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjdiZGY4YTczOWYwZjQwMDYzNGNjZDdmXyRfY2M9NDk1NmJmM2UtNjA4Ni04Y2FmLWRjMTUtMWU4Y2Q1ZDY4YmM4Jm12PTY3YmRmOGE3MzlmMGY0MDA2MzRjY2Q4MSZwaT1jbXA=',
      title: 'One Year FREE',
      description: 'Anytime, anywhere consultations with \ntrusted vet professionals via Petzey',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67bdf8a739f0f400634ccd81/2d4835dd4f389cb3b0a567eaae6f234f2e47eb93/original.jpg?1740503470',
      created: '2025-03-04T09:00:00.000Z',
      updated: '2025-03-04T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-04-03T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Special Offer!',
        campaign: 'petzey2025',
        location: 'home',
        priority: '40',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9ODljNDYyOWEtZDAxOS1lMDE3LWIwZTEtMDJhODA4NDcxNDRhJm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-03-04T09:00:00.000Z',
      updated: '2025-03-04T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-11T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9MjQ1ZjBiZDUtMDkyOC1lMjA5LThiMGQtNDRkMTgzMzU1Zjk5Jm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-03-03T09:00:00.000Z',
      updated: '2025-03-03T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-10T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5N2Q0NjQxMWRhNDMwMDY0ZDM0NDRhXyRfY2M9NjM2MGY4YWUtYzkyNy1hODRiLTdiZGItM2JkOWEzMWE2Yzk1Jm12PTY3OTdkNDY1MTFkYTQzMDA2NGQzNDQ0YyZwaT1jbXA=',
      title: 'FREE Treats. Exclusively in the myPurina App.',
      description:
        'Get a coupon for a FREE package of treats (up to $4.00), in the myPurina app. Plus, earn 10 points for every $1 spent on Purina products, get FREE samples, coupons, and 250 bonus points just for signing up!',
      url: 'https://mypurina.onelink.me/z05v/freetreatsoffers',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6797d46511da430064d3444c/95c8059c002b3675d5b66b0c46a8d94a38f838f7/original.jpg?1738005881',
      created: '2025-02-28T09:00:00.000Z',
      updated: '2025-02-28T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-07T09:00:00.000Z',
      linkText: 'Get the App',
      extras: {
        format: 'web_classic_card',
        campaign: 'free_treats_coupon',
        location: 'offer_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc1MjAxZTEyZjBjN2EwMDY2NGZhNTg5XyRfY2M9OGMzMTkyZmUtNjViZi02ZTE1LTFlMWQtZmUwM2JiYTMxMjYyJm12PTY3NTIwMWUxMmYwYzdhMDA2NjRmYTU4MCZwaT1jbXA=',
      title: 'The App for You and Your Pet',
      description:
        'Get freebies, earn rewards and more! myPurina gives you 10 points for every $1 spent on Purina products, plus a bonus at sign up!',
      url: 'https://mypurina.onelink.me/z05v/plp1725915304',
      aspectRatio: 1,
      viewed: true,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/675201e12f0c7a00664fa580/684ea704a5ce42ef8a10cab8b964b401a36e4bc3/original.jpg?1733427686',
      created: '2025-02-22T05:55:00.000Z',
      updated: '2025-02-22T05:55:00.000Z',
      categories: [],
      expiresAt: '2025-03-24T05:55:00.000Z',
      linkText: 'Download myPurina',
      extras: {
        format: 'web_classic_card',
        campaign: 'mypurina_2',
        location: 'product_listing',
        priority: '1',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc1MjAyMWMzM2RlYWUwMDYzNzZkOGE5XyRfY2M9NWE2ZDljZTMtNWVlZC1iODJmLTEzOTYtMmM2ZGI4ODdmOWYwJm12PTY3NTIwMjFjMzNkZWFlMDA2Mzc2ZDhhMCZwaT1jbXA=',
      title: 'The App for You and Your Pet',
      description:
        'Get freebies, earn rewards and more! myPurina gives you 10 points for every $1 spent on Purina products, plus a bonus at sign up!',
      url: 'https://mypurina.onelink.me/z05v/plp1725915304',
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6752021c33deae006376d8a0/d71f2d22098f572bca8284c37dc83a78ab656d38/original.jpg?1733427744',
      created: '2025-02-22T05:55:00.000Z',
      updated: '2025-02-22T05:55:00.000Z',
      categories: [],
      expiresAt: '2025-03-24T05:55:00.000Z',
      linkText: 'Download myPurina',
      extras: {
        format: 'web_classic_card',
        campaign: 'mypurina_2',
        location: 'product_listing',
        priority: '2',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc5MTcyNTZiNTIzOGYwMDYzODUzNWU3XyRfY2M9ZWVlOGMzMmUtYWNmYS02YTMzLWY1MjQtNjA3ZWNhNTAxNzhiJm12PTY3OTE3MjU2YjUyMzhmMDA2Mzg1MzVlOSZwaT1jbXA=',
      title: 'Earn Double Points',
      description: 'Upload a Moist & Meaty receipt, and earn 2X the points on your purchase!',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/67917256b5238f00638535e9/9c25ef65720a3512e60cfc60aa305a11332925fb/original.jpg?1737585505',
      created: '2025-02-17T09:00:00.000Z',
      updated: '2025-02-17T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-19T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        add_desc: 'Ends 12/31',
        campaign: 'MoistMeaty_2x',
        location: 'offers',
        priority: '45',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjcyYjkzMDMyN2FkZDgwMDYzMTAzZWE5XyRfY2M9MWQ4MTVkOTQtMzYxNC1kOTg4LTJhMTAtNjg0NWU3YzE1NGU5Jm12PTY3MmI5MzAzMjdhZGQ4MDA2MzEwM2VhNSZwaT1jbXA=',
      title: 'Train and Play',
      description: 'Find articles and videos to help connect with your pet.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/672b930327add80063103ea5/4f96d7986a35b9e31c4ec9dbc0353a8017374999/original.jpg?1730908934',
      created: '2025-02-14T09:00:00.000Z',
      updated: '2025-02-14T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-16T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'Train and Play',
        location: 'discover',
        priority: '97',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'Njc1OWNkOGM3OGI4YzcwMDY0Mzc1Nzk3XyRfY2M9OWNlZjFkNzQtZWJmYS0wZjY2LWZhNzQtYTAwY2ZmNjYxZTI5Jm12PTY3NTljZDhjNzhiOGM3MDA2NDM3NTc5MyZwaT1jbXA=',
      title: 'Calculate a Custom Feeding Plan',
      description: 'Get a personalized guide for your pet',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6759cd8c78b8c70064375793/e852afa25bd717b1c5450cc6119bc2fe5cf28296/original.png?1733938576',
      created: '2025-02-14T09:00:00.000Z',
      updated: '2025-02-14T09:00:00.000Z',
      categories: [],
      expiresAt: '2025-03-16T09:00:00.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'feeding_guide',
        location: 'discover',
        priority: '70',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjczNGZmNzFiMTRjNWUwMDY2NDMyNDRmXyRfY2M9NDBkOGJlZjctMjJiNC0zMDc0LTAwNmEtNGJiNDhkZWYwYTU5JmRpJmRtJm12PTY3MzRmZjcxYjE0YzVlMDA2NjQzMjQ1MSZvZCZwaT13ZnMmdz02NzM0ZmY3MWIxNGM1ZTAwNjY0MzI0NGMmd3A9MjAyNS0wMi0xM1QxOSUzQTQ1JTNBMTYuMDAwWiZ3dj02NzM0ZmY3MWIxNGM1ZTAwNjY0MzI0NTY=',
      title: 'Earn more points when you scan!',
      description: 'Have a receipt? Upload now to earn even more points.',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6734ff71b14c5e0066432451/50add40b3b46fd029a89e13e5996413d3f1a4fcd/original.jpg?1731526516',
      created: '2025-02-13T19:45:22.000Z',
      updated: '2025-02-13T19:45:22.000Z',
      categories: [],
      expiresAt: '2025-03-15T19:45:22.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'upload receipt',
        location: 'home',
        priority: '10',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
    {
      id: 'NjczNGYzYTAwYzIzMTcwMDY0NzBjYjE3XyRfY2M9N2ZkMGE1ZGItNTUyMS01ZTZhLTQ1NWItMTIxZWU3MGFiNTdlJmRpJmRtJm12PTY3MzRmM2EwMGMyMzE3MDA2NDcwY2IxOSZvZCZwaT13ZnMmdz02NzM0ZjNhMDBjMjMxNzAwNjQ3MGNiMTQmd3A9MjAyNS0wMi0xM1QxOCUzQTU1JTNBMTcuMDAwWiZ3dj02NzM0ZjNhMDBjMjMxNzAwNjQ3MGNiMWU=',
      title: "Find your pet's perfect food.",
      description: 'Try the Pet Food Finder today. ',
      url: null,
      aspectRatio: 1,
      viewed: false,
      imageUrl:
        'https://braze-images.com/appboy/communication/marketing/content_cards_message_variations/images/6734f3a00c2317006470cb19/0dcb310e244f86806a3bbd8756ddc17bd31f437a/original.jpg?1731523491',
      created: '2025-02-13T18:55:52.000Z',
      updated: '2025-02-13T18:55:52.000Z',
      categories: [],
      expiresAt: '2025-03-15T18:55:52.000Z',
      linkText: '',
      extras: {
        format: 'medium',
        campaign: 'pet food finder',
        location: 'home, discover',
        priority: '20',
      },
      pinned: false,
      dismissible: true,
      dismissed: false,
      clicked: false,
      isControl: false,
      test: false,
      ka: null,
      ke: null,
      Yc: 'ab-classic-card',
      jd: true,
    },
  ],
  lastUpdated: '2025-03-06T20:30:31.000Z',
};
